import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

import PropTypes from 'prop-types';
import { BillingSelectors } from '../../../Redux/modules/billing/selectors';

import styles from './BillingContainer.module.less';
import Billing from '../components/Billing';
import { BillingActions } from '../../../Redux/modules/billing/actions';
import { AppSelectors } from '../../../Redux/modules/app/selectors';

const billingContainer = (props) => {
  useEffect(() => {
    props.onFetchBillingInfo();
    props.onFetchInvoices(1);
  }, []);

  return (
    <div className={styles.container}>
      <Helmet>
        <title>{gettext('Billing')}</title>
      </Helmet>
      <div className={styles.section}>
        <Billing
          data={props.billingInformation}
          invoices={props.invoices}
          paginationObject={props.paginationObject}
          fetchInvoices={props.onFetchInvoices}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    billingInformation: BillingSelectors.billingSelector(state),
    invoices: BillingSelectors.invoicesSelector(state),
    isLoading: AppSelectors.loaderSelector(state),
    paginationObject: BillingSelectors.paginationSelector(state),
  };
};

const mapDispatchToProps = {
  onFetchBillingInfo: BillingActions.billingInfoFetch,
  onFetchInvoices: BillingActions.invoicesFetch,
};

billingContainer.propTypes = {
  onFetchBillingInfo: PropTypes.func,
  billingInformation: PropTypes.object,
  onFetchInvoices: PropTypes.func,
  invoices: PropTypes.array,
  isLoading: PropTypes.bool,
  paginationObject: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(billingContainer);
